
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Dashboard = lazy(() => import("@/pages/borrower/Dashboard"));
const Loans = lazy(() => import("@/pages/borrower/Loans"));
const Apply = lazy(() => import("@/pages/borrower/Apply"));
const PreApproval = lazy(() => import("@/pages/borrower/PreApproval"));
const PreApprovals = lazy(() => import("@/pages/borrower/PreApprovals"));
const Documents = lazy(() => import("@/pages/borrower/Documents"));
const LendersList = lazy(() => import("@/pages/borrower/Lenders"));
const LenderDetails = lazy(() => import("@/pages/borrower/lenders/LenderDetails"));
const Settings = lazy(() => import("@/pages/borrower/Settings"));
const Investments = lazy(() => import("@/pages/borrower/Investments"));
const Messages = lazy(() => import("@/pages/borrower/Messages"));
const PropertyPortfolio = lazy(() => import("@/pages/borrower/PropertyPortfolio"));
const GuaranteeCheque = lazy(() => import("@/pages/borrower/GuaranteeCheque"));

export const borrowerRoutes: RouteObject[] = [
  {
    path: "borrower",
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "loans",
        element: <Loans />,
      },
      {
        path: "apply",
        element: <Apply />,
      },
      {
        path: "pre-approval",
        element: <PreApproval />,
      },
      {
        path: "pre-approvals",
        element: <PreApprovals />,
      },
      {
        path: "documents",
        element: <Documents />,
      },
      {
        path: "lenders",
        element: <LendersList />,
      },
      {
        path: "lender/:id",
        element: <LenderDetails />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "investments",
        element: <Investments />,
      },
      {
        path: "messages",
        element: <Messages />,
      },
      {
        path: "properties",
        element: <PropertyPortfolio />,
      },
      {
        path: "guarantee-cheque/:loanId",
        element: <GuaranteeCheque />,
      },
    ],
  },
];
